import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration, getCurrencySymbol, getCurrencyValue, getPrintableAmount } from '../../data/utils';
import { getLabel } from '../../InitData';
import { taxesEnabled } from '../../data/purchase-service';
import BookedTicket from '../booked-ticket/BookedTicket';
import Modal from '../Modal';
import { openModal } from '../ModalContainer';
import { xs_isMobile } from '../..';

function PotentialWinBox(props) {
    const conf = getConfiguration();
	const betslipContext = useContext(BetslipContext) ;
    const betslipData = betslipContext.getBetslipData();
    const couponKey = props.couponKey;
    const container = props.container;
    const coupon = betslipData.coupons[couponKey];
	const totalTaxAmount = coupon.totalTaxAmount? coupon.totalTaxAmount : 0;
	const showTaxes = taxesEnabled() && totalTaxAmount > 0;
    
    const potentialWinning = getPrintableAmount(coupon.potentialWinning, conf.cs.m, conf.cs.nd);
    const potentialWinMin =  getPrintableAmount(coupon.minPotentialWinning, conf.cs.m, conf.cs.nd);
  	const potentialWinMax =  getPrintableAmount(coupon.maxPotentialWinning, conf.cs.m, conf.cs.nd);
    let amountSrc = 0;
    
    const stakeTaxedJustAdvice = betslipContext.stakeTaxConfiguration.enabled && 
    							 betslipContext.stakeTaxConfiguration.type === 'advice_for_online_distro';
    
    const stakeTaxedForPurchase = betslipContext.stakeTaxConfiguration.enabled && 
	 							  betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
    
    let stakeTaxedAmountSrc = 0;
    let stakeTaxedPotentialWinning = 0;
    // let stakeTaxedMinPotentialWinning = 0; // only for systembets
    // let stakeTaxedMaxPotentialWinning = 0; // only for systembets
    
    // bonusMulti
    const bonusDataMulti = coupon.multipleBonus;
    let potentialWinningNoBonusMulti = 0;
    let bonusWinMulti = 0;
    let descBonusMulti = "Bonus";
    
    // bonusSystem
    let bonusSystemData = null;
    let descBonusSystem = "Bonus";
    
    if (container === 'singlebets') {
    	amountSrc = coupon.amountSingle;
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSingle;
    	}
    } else if (container === 'multibets') {
    	amountSrc = coupon.amountMulti;
    	if (bonusDataMulti?.applied) {
    		potentialWinningNoBonusMulti = getPrintableAmount(bonusDataMulti.potentialWinningNoBonus, conf.cs.m, conf.cs.nd);
    		bonusWinMulti = getPrintableAmount(bonusDataMulti.bonusAmount, conf.cs.m, conf.cs.nd);
    		descBonusMulti = bonusDataMulti.description;
    	}
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountMulti;
    	}
    } else {
    	amountSrc = coupon.amountSystem;
    	bonusSystemData = coupon.bonusSystemData;
    	if (bonusSystemData != null && bonusSystemData.applied) {
    		descBonusSystem = bonusSystemData.description != null && bonusSystemData.description !== '' ? bonusSystemData.description : descBonusSystem;
    	} else {
    		bonusSystemData = {
    			applied : false	
    		};
    	}
    	
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSystem;
    	}
    }
    
    let totalAmount = getPrintableAmount(amountSrc, conf.cs.m, conf.cs.nd);
    let stakeTaxedTotalAmount = null;
    const showTaxedTotalAmount = stakeTaxedForPurchase; // TO remove definetely if in the future we wont have a skin that requires it
	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
		stakeTaxedTotalAmount = getPrintableAmount(stakeTaxedAmountSrc, conf.cs.m, conf.cs.nd);
		stakeTaxedPotentialWinning = getPrintableAmount(coupon.stakeTaxedPotentialWinning, conf.cs.m, conf.cs.nd);
		// stakeTaxedMinPotentialWinning =  getPrintableAmount(coupon.stakeTaxedMinPotentialWinning, conf.cs.m, conf.cs.nd);
		// stakeTaxedMaxPotentialWinning =  getPrintableAmount(coupon.stakeTaxedMaxPotentialWinning, conf.cs.m, conf.cs.nd);
	}

    let taxedStakeAmountLabel = getLabel('betslip.taxed_stake');
    let taxedStakeWinningLabel = getLabel('betslip.taxed_stake_winning');
    if(stakeTaxedJustAdvice || stakeTaxedForPurchase){
    	taxedStakeAmountLabel = taxedStakeAmountLabel.replace(/{{PERCENTAGE}}/g,  betslipContext.stakeTaxConfiguration.percentage / 100 + "%");
    }
    
    
    // MAX PAID STUFF, IF THE CUSTOMER HAS IT IN ITS CONFIGURATION
    let maxPaidPotentialWinning = null;
    let maxPaidPotentialWinMin =  null;
    let maxPaidPotentialWinMax =  null;
    let maxPaidStakeTaxedPotentialWinning = null;
    
    if(container === 'systembets' ){
    	if(conf.sbmw !== 0 && conf.mwspw){
    		if(coupon.potentialWinning > conf.sbmw){
    			maxPaidPotentialWinning = getPrintableAmount(conf.sbmw, conf.cs.m, conf.cs.nd);
    		}
    		if(coupon.minPotentialWinning > conf.sbmw){
    			maxPaidPotentialWinMin = getPrintableAmount(conf.sbmw, conf.cs.m, conf.cs.nd);
    		}
    		if(coupon.maxPotentialWinning > conf.sbmw){
    			maxPaidPotentialWinMax = getPrintableAmount(conf.sbmw, conf.cs.m, conf.cs.nd);
    		}
    		if(coupon.stakeTaxedPotentialWinning > conf.sbmw){
    			maxPaidStakeTaxedPotentialWinning = getPrintableAmount(conf.sbmw, conf.cs.m, conf.cs.nd);
    		}
    	}
    }
    else{
    	if(conf.mbmw !== 0 && conf.mwmpw){
    		if(coupon.potentialWinning > conf.mbmw){
    			maxPaidPotentialWinning = getPrintableAmount(conf.mbmw, conf.cs.m, conf.cs.nd);
    		}
    		if(coupon.stakeTaxedPotentialWinning > conf.mbmw){
    			maxPaidStakeTaxedPotentialWinning = getPrintableAmount(conf.mbmw, conf.cs.m, conf.cs.nd);
    		}
    	}
    }

	function reserveTicket(){
		betslipContext.reserveTicket((reservationCode) => {
			openModal(
	            <Modal type={xs_isMobile ? 'mobile-full' : null}>
	                <BookedTicket reservationCode={reservationCode} />
	            </Modal>
        	)	
		})
	}
	const playButtonState = betslipContext.getPlayButtonState();
    function changeButtonState(buttonState) {
    	betslipContext.setPlayButtonState(buttonState);
    }
   /*openModal(
        <Modal>
            <BookedTicket reservationCode={"591975"} />
        </Modal>
   )*/
    return <>
            {
            	container !== 'systembets' &&
	            <div className="b_12_1">
	                <div className="b_12_1_1">{getLabel('carrello.total_odds', getLabel('betslip.total_odds'))}</div>
	                <div className="b_12_1_2">{coupon.totalOdd}</div>
	            </div>
            }
            {
            	container === 'systembets' && <>
	            <div className="b_12_1">
	                <div className="b_12_1_1">{getLabel('mybets.combinazioni')}</div>
	                <div className="b_12_1_2">{coupon.totalCombs}</div>
	            </div>  
	            <div className="b_12_1">
	                <div className="b_12_1_1">{getLabel('carrello.min_winnings', getLabel('betslip.min_winnings'))}</div>
	                <div className="b_12_1_2">{potentialWinMin}</div>
	            </div>              	
 	            <div className="b_12_1">
	                <div className="b_12_1_1">{getLabel('carrello.max_winnings', getLabel('betslip.max_winnings'))}</div>
	                <div className="b_12_1_2">{potentialWinMax}</div>
	            </div>    
            	</>
            
            }
            {props.children}

            {container === 'multibets' && bonusDataMulti?.applied &&
                <div className="b_12_5">
                 	<span className="b_12_5_1">{descBonusMulti.toUpperCase()}</span>
                    <span className="b_12_5_2_1"> {bonusWinMulti} </span>
        		</div>
        	}
        	{container === 'systembets' && bonusSystemData?.applied &&	
        		<div className="b_12_5">
                 	<span className="b_12_5_1">{descBonusSystem.toUpperCase()}</span>
                    <span className="b_12_5_2_1"> {getCurrencyValue((bonusSystemData.bonusMax * conf.cs.m), conf.cs.m, conf.cs.nd, conf.cs.ct)} </span>
        		</div>
        	}
            <div className="b_12_5">
                <span className="b_12_5_1">{getLabel('carrello.potential_winnings', getLabel('betslip.potential_winnings'))}</span>
                <div className="b_12_5_2">
                    <span className="b_12_5_2_1">{stakeTaxedForPurchase? (maxPaidStakeTaxedPotentialWinning? maxPaidStakeTaxedPotentialWinning : stakeTaxedPotentialWinning) : (maxPaidPotentialWinning? maxPaidPotentialWinning : potentialWinning)}</span>
                    <span className="b_12_5_2_2">{getCurrencySymbol(conf.cs.ct)}</span>
                </div>
            </div>
            {
            	betslipContext.betslipMode === 'BUY' && <>
	            	{(playButtonState === 'play' || playButtonState === 'again') && 
			             <button type="button" className="c_52" onClick={() => changeButtonState('confirm')}>
			                <div className="c_52_1">{getLabel('carrello.button.gioca', getLabel('betslip_alt.button.place_bet'))}</div>
			            </button> 
		            }  
		            {playButtonState === 'confirm' && <>
			             <button type="button" className="c_52" onClick={() => changeButtonState('play')}>
			                <div className="c_52_1">{getLabel('carrello.go_back', getLabel('betslip.go_back', 'Abort'))}</div>
			            </button> 
			            <button type="button" className="c_52" onClick={() => betslipContext.purchase()}>
			                <div className="c_52_1">{getLabel('carrello.ok', getLabel('betslip.ok', 'Confirm'))}</div>
			            </button> 		                   
		            </>
		            }         	
            	</>
            }
            {
	            betslipContext.betslipMode === 'BOOK_FOR_AGENCY' && 
	             <button type="button" className="c_52" onClick={reserveTicket}>
	                <div className="c_52_1">{getLabel('betslip.prepare_for_agency', 'Prepare ticket')}</div>
	            </button>           
            }

    </>
}

export default PotentialWinBox;